// Function loadSupplierListingBlock loads the supplierProductBlock class by dynamically importing the js on demand if needed

export function loadSupplierListingBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-supplier-listing-block-chunk" */ '../widgets/supplierListingBlock').then(wg => {

		const { SupplierListingBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="SupplierListingBlock"]');

		if(!$wg) {
			// console.info('SupplierListingBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="SupplierListingBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new SupplierListingBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new SupplierListingBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the SupplierListingBlock widget');

}